import {
    type FC
} from "react";
import type ITimelineEmphasisProps from "./type";
import type {
    TimelinePartContentProps
} from "../../type";
import {
    withTimelineContext
} from "../../context";
import Text from "../../../text";

const TimelineEmphasisContent: FC<TimelinePartContentProps<ITimelineEmphasisProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    ...props
}) => {
    return <Text
        {...props}
        customTheme={customThemeProp ?? context.customTheme}
        variant="labelMediumSize"
        color="high"
    >
        {children}
    </Text>;
};
export default withTimelineContext("Emphasis", TimelineEmphasisContent);
